
import { BASENAME_URL_COOKIES_POLICIES } from "constants/settings";

export const routeToCookiePolicy = (navigate,type) => {
    navigate(
        BASENAME_URL_COOKIES_POLICIES,
        { state: { type: type } }
    )
}